module.exports = __webpack_public_path__ + "img/vcjhd.b492f0e3.png";